/* @flow */
import styled, { css } from "styled-components";
import { fontSize, rtl } from "../common/styled-mixins";

export const Container = styled.div`
  position: relative;
  width: 100%;
  font-size: 16px;
  font-family: Roboto, Arial, sans-serif;
`;

export const ContainerInner = styled.div`
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
  padding: 33px 10px 0;

  @media (max-width: 959px) {
    padding-top: 0;
  }
`;

export const Flex = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
`;

export const Top = styled(Flex)`
  height: 3.167em;
  font-size: 30px;
  line-height: 1;

  @media (max-width: 959px) {
    height: 2.611em;
  }

  @media (max-width: 736px) {
    font-size: 26px;
  }

  @media (max-width: 640px) {
    font-size: 24px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
  }

  @media (max-width: 414px) {
    font-size: 26px;
  }

  @media (max-width: 360px) {
    font-size: 24px;
  }

  @media (max-width: 320px) {
    font-size: 18px;
  }
`;

export const Title = styled.h1`
  margin: 0;
  padding: 0;
  font-weight: 300;
  font-size: inherit;
  line-height: inherit;
  text-align: center;
  color: #a5a4a4;
`;

export const CalendarContainer = styled(Flex)`
  min-height: 90px;
  padding: 0 29px;
  background-color: ${({ theme }) =>
    theme.calendarContainerBackground
      ? "rgba(255, 255, 255, 0.05)"
      : "#f6f6f6"};
  border-radius: 4px;

  @media (min-width: 960px) and (-ms-high-contrast: none),
    (-ms-high-contrast: active) {
    height: 90px;
  }

  @media (max-width: 959px) {
    min-height: 73px;
    padding: 16px 14px 7px;
  }

  @media (max-width: 479px) {
    flex-direction: row;
    justify-content: flex-start;
    padding-bottom: 14px;
  }
`;

export const CalendarInner = styled(Flex)`
  flex: 0 1 882px;

  @media (max-width: 959px) {
    justify-content: space-around;
    flex: 1 1 auto;
  }

  @media (max-width: 479px) {
    flex-direction: row;
    justify-content: flex-start;
  }
`;

export const Button = styled.button`
  width: 150px;
  min-height: 39px;
  margin-left: auto;
  font-weight: 700;
  font-size: ${fontSize(16)};
  text-align: center;
  color: #fff;
  background-color: #887d96;
  background: linear-gradient(to bottom, #887d96, #605073);
  border: none;
  border-radius: 8px;
  cursor: pointer;

  :hover {
    color: #fff;
    background-color: #605073;
    background: linear-gradient(to bottom, #605073, #887d96);
    outline: none;
  }

  ${({ theme }) =>
    theme.isHistoryPopup &&
    theme.mode === "dark" &&
    css`
      color: #ffffff;
      background: none;
      border: 2px solid #ffffff;

      :hover {
        color: #1b546a;
        background: #ffffff;
      }
    `};

  :hover,
  :focus,
  :active {
    outline: none;
  }

  @media (max-width: 959px) {
    flex: 1 0 auto;
    width: auto;
  }

  @media (max-width: 736px) {
    min-height: 36px;
    padding: 0 6px;
  }

  @media (max-width: 640px) {
    min-height: 32px;
    font-size: ${({ theme }) =>
      theme.locale === "ar" ? theme.minFontSize : "14px"};
  }

  @media (max-width: 414px) {
    min-height: 36px;
    padding: 0 4px;
    font-size: 16px;
  }

  @media (max-width: 360px) {
    min-height: 32px;
    font-size: ${({ theme }) =>
      theme.locale === "ar" ? theme.minFontSize : "14px"};
    margin: 5px auto;
    flex: 0 0 auto;
  }
`;

export const Header = styled.span`
  direction: ${({ theme }) => theme.direction};
  ${rtl("margin-right", "0.625em")};
  font-weight: 400;
  font-size: ${fontSize(16)};
  color: ${({ theme }) => theme.calendarTitle || "#343434"};

  ${props =>
    props.headerWidth &&
    css`
      @media (min-width: 960px) {
        flex-basis: ${props.headerWidth ? props.headerWidth : "auto"};
        margin-right: 0;
        padding-bottom: 0.5em;
      }
    `};

  @media (max-width: 959px) {
    text-align: left;
  }

  @media (max-width: 640px) {
    font-size: ${({ theme }) =>
      theme.locale === "ar" ? theme.minFontSize : "14px"};
    margin-right: 0.286em;
  }

  @media (max-width: 414px) {
    font-size: 16px;
  }

  @media (max-width: 360px) {
    font-size: ${({ theme }) =>
      theme.locale === "ar" ? theme.minFontSize : "14px"};
  }

  ${props =>
    props.theme.direction === "rtl" &&
    css`
      @media (max-width: 640px) {
        margin-right: 0;
        margin-left: 0.286em;
      }
    `};
`;

export const MobilePeriodInner = styled(Flex)`
  min-height: 51px;
`;



// WEBPACK FOOTER //
// ./src/components/HistoryPages/shared-styles.js